import { DesktopIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Computer = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <DesktopIcon {...rest} size={Sizes[size]} color={fill} />;
};

Computer.displayName = 'Computer';
